var result = {
  mac: false,
  supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
  result.mac = /Mac/.test(navigator.platform);
  result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
export default result;